import { gql } from '@apollo/client'

export const GET_BACKUP_APPROVERS_BY_USER = gql`
  query GetBackupApproversByPrimaryApprover(
    $input: GetBackupApproversByPrimaryApproverRequestInput!
  ) {
    backupApproversByPrimaryApprover(request: $input) {
      backupApprovers {
        id
        workflowApproverEmail
        backupApproverEmail
        approverGroupId
        region
        markets
        countryCodes
        productLines
        backupBeginDate
        backupEndDate
        isActive
      }
      didError
      errorMessage
      __typename
    }
  }
`
